<template>
  <HalfScreenDialog
    class="tnc-dialog"
    :title="tI18n('條款及細則')"
    ref="tncDialog"
    :isAppendToBody="true">
    <div slot="bd">
      <div class="tnc-frame">
        <TncSkeleton :isReady="!!tncContent">
          <div
            class="tnc-content"
            v-html="tncContent"
            v-stat.brow="{ tag: 'tnc-dialog.comp-brow', ext: { fext: JSON.stringify(biExt) } }">
          </div>
        </TncSkeleton>
        <div class="tnc-mask"></div>
      </div>
    </div>
  </HalfScreenDialog>
</template>

<script lang="ts">
import { FitHalfScreenDialogV2 } from '@tencent/wphk-ui';
import { defineComponent, nextTick, ref } from 'vue-demi';
import { getTncConfigContent } from './format-tnc';
import TncSkeleton from './tnc-skeleton.vue';
import { i18n } from './i18n';

export default defineComponent({
  name: 'TncDialog',
  components: {
    HalfScreenDialog: FitHalfScreenDialogV2,
    TncSkeleton,
  },
  props: {
    /** biExt上报扩展 */
    biExt: Object,
    /** tnc的url */
    tncUrl: String,
  },
  setup(prop) {
    // tnc 配置内容
    const tncContent = ref('');
    // tnc 弹窗
    const tncDialog = ref<FitHalfScreenDialogV2 | null>(null);
    // 开启tnc弹窗
    async function showTncDialog() {
      if (!prop.tncUrl) return;
      nextTick(() => tncDialog.value?.showDialog());
      tncContent.value = await getTncConfigContent(prop.tncUrl);
    }
    // 关闭tnc弹窗
    function hideTncDialog() {
      tncDialog.value?.hideDialog();
    }
    return {
      tncDialog,
      tncContent,
      showTncDialog,
      hideTncDialog,
    };
  },
  methods: {
    tI18n: i18n,
  },
});
</script>

<style lang="less">
@import './less/index.less';
@import '~@wphk-ui/styles/fonts.less';

.tnc-dialog {
  .weui-icon-btn_close {
    width: 24 / @rem;
    height: 48 / @rem;
    background-image: url('https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20230619115916/close.png');
  }

  .weui-half-screen-dialog__hd {
    box-sizing: border-box;
  }
  .weui-half-screen-dialog__bd {
    // max-height: 75vh;
    max-height: calc(100vh - 184px);
  }
}
.tnc-frame {
  width: 100%;
  height: 1000 / @rem;
  position: relative;
  .font-24-regular(#000000cf);
  position: relative;
  overflow-y: scroll;
  .tnc-content {
    white-space: pre-line;
    padding-bottom: 120 / @rem;
    overflow-x: hidden;
  }
  .tnc-mask {
    position: fixed;
    bottom: 0 / @rem;
    height: 120 / @rem;
    width: calc(100% - 0.32rem);
    background: linear-gradient(
      180deg,
      #FFFFFF 0%,
      rgba(255, 255, 255, 0.75) 40%,
      rgba(255, 255, 255, 0.5) 80%,
      rgba(255, 255, 255, 0) 100%);
    transform: rotate(-180deg);
  }
}
</style>
